module.exports = __webpack_public_path__ + "img/Essex Finney as Cadet, 1959.4dc2bb56.jpg";